import { ACTION, ChangeCaseType, ChangeCaseTypeFailure, ChangeCaseTypeSuccess } from './action-types';
import { CaseState } from 'app/area/case/types-store';
import { ActionMap } from 'app/area/case';

export const reducers: ActionMap = {

  [ACTION.CHANGE_CASE_TYPE]: (state: CaseState, action: ChangeCaseType): CaseState => {
    return {
      ...state,
      ...{
        fetching: true
      }     
    };
  },
  [ACTION.CHANGE_CASE_TYPE_SUCCESS]: (state: CaseState, action: ChangeCaseTypeSuccess): CaseState => {
    return {
      ...state,      
      ...{
        fetching: false
      },
      editing: {
        ...state.editing,
        ...{
          etag: action.etag
        }
      }
    };
  },
  [ACTION.CHANGE_CASE_TYPE_FAILURE]: (state: CaseState, action: ChangeCaseTypeFailure): CaseState => {
    return {
      ...state,
      ...{
        fetching: false
      }
    };

  }  

};
